import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CertificadoNoAdeudoService } from "../../servicios/certificado-no-adeudo.service";
import { ActivatedRoute, Router } from "@angular/router";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import {
  CertificadoNoAdeudo,
  AuxJasper,
  ParametroJasper,
  RegistroBitacoraInput, EstadoCuentaInformacionInput, SolicitudDetalles, FlujoTramitesInput 
} from "../../entidades/entidades";
import { AuthenticationService } from '../../servicios/authentication.service';
import { RegistroBitacoraService } from '../../servicios/registro-bitacora.service';
import { SolicitudDetallesService } from "../../servicios/solicitud-detalles.service";
import { FlujoTramitesInputService } from '../../servicios/flujo-tramites.service';
import { AguasService } from '../../servicios/aguas.service';

@Component({
  selector: "app-certificado-no-adeudo",
  templateUrl: "./certificado-no-adeudo.component.html",
  styleUrls: ["./certificado-no-adeudo.component.css"],
})
export class CertificadoNoAdeudoComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  certificadoNoAdeudoForm: FormGroup;
  display: boolean = false;
  usuario: any;
  public solicitud : number;

  public IdSolicitud: number;
  public numSolicitud: number;
  public IdAgua: number;
  datos: any;
  public cetSolicitud: number;
  public idConcepto: number;

  showDialog() { this.display = true; }
  @Input("certificadoNoAdeudo") certificadoNoAdeudo: CertificadoNoAdeudo;
  @Output("certificadoNoAdeudoOutput") certificadoNoAdeudoOutput: EventEmitter<CertificadoNoAdeudo>;
  public estadoCuentaInformacionInput$ = new EventEmitter<EstadoCuentaInformacionInput>();
  public estadoCuentaInformacionLimpio: EstadoCuentaInformacionInput;
  auxJasper: AuxJasper;
  public registroBitacora = new RegistroBitacoraInput();
 
  constructor(
    private formBuilder: FormBuilder,
    private certificadoNoAdeudoService: CertificadoNoAdeudoService,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private solicitudDetallesService: SolicitudDetallesService,
    private flujoTramitesInputService: FlujoTramitesInputService,
    private registroBitacoraService: RegistroBitacoraService,
    private aguasService: AguasService,
  ) {
    this.certificadoNoAdeudoOutput = new EventEmitter();
  }

  async ngOnInit() 
  {
    try
    {
      

      this.certificadoNoAdeudoForm = this.formBuilder.group({
        id: [undefined],
        cuentaAgua: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
        cuentaAguaAnterior: [
          undefined,
        ],
        cuentaPredial: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
        fechaUltimoUltimoPago: [undefined],
        añoUltimoPago: [undefined],
        propietario: [undefined],
        domicilioCuentaAgua: [undefined],
        domicilioPersona: [undefined],
        uso: [undefined],
        tipoServicio: [undefined],
        tipoToma: [undefined],
      });
    
      await this.authenticationService.getUserByToken();
      this.usuario = this.authenticationService.currentUserValue;
      this.datos = history.state.example;
      if (this.datos) {
        this.IdSolicitud = this.datos.idSolicitudDetalle;
        this.IdAgua = this.datos.idAgua;
        console.log("this.router: ", this.datos.idSolicitudDetalle);
        
        
        this.confirmaSolicitud();
        this.ObtieneInfo();
      } else {
        this.router.navigateByUrl("/");
      }
    } catch {
      this.muestraMensaje.notification(
        "No existe una solicitud Previa",
        "top",
        "center"
      );
  }
}

  async confirmaSolicitud() {
    try {
      const datoRetorno = await this.solicitudDetallesService
        .getSingle(this.IdSolicitud)
        .toPromise();
      let solDetalle = new SolicitudDetalles();
      solDetalle = datoRetorno;
      this.cetSolicitud = datoRetorno.idSolicitud;
      this.idConcepto = datoRetorno.idConcepto;

      console.log("datoRetorno: ", datoRetorno);

      if (datoRetorno.id == 0) {
        this.muestraMensaje.error(
          "Esta solicitud no corresponde a una baja de cuenta",
          "top",
          "center"
        );
        this.router.navigateByUrl("/");
    
      }
      // if(solDetalle.idEstatus == 2 || solDetalle.idEstatus == 4)
      // {
      //   this.muestraMensaje.error("Este servicio ya pasó por Ejecución", "top", "center");
      //   this.router.navigateByUrl("/");
      // }
    } catch {
    } finally {
      console.log("Paso por confirmaSolicitud");
    }
  }

  async ObtieneInfo() {
    try {
      await this.estadoCuentaInformacionInput$.emit(null);
      let estadoCuentaInformacionInput = new EstadoCuentaInformacionInput();
      estadoCuentaInformacionInput.idAgua = this.IdAgua;

      debugger;

      if (estadoCuentaInformacionInput?.idAgua != null) {
        await this.estadoCuentaInformacionInput$.emit(
          estadoCuentaInformacionInput
        );
        
        const retornaAgua = await this.aguasService.getSingle(estadoCuentaInformacionInput.idAgua).toPromise();
        this.certificadoNoAdeudoForm.patchValue(
          {
            cuentaAgua: retornaAgua.cuentaAgua
          }
        );
        this.registroBitacora.idAgua = this.IdAgua;
        this.registroBitacora.idMovAsegurar = 1;
        this.registroBitacora.accion = "SE GENERO CERTIFICADO DE NO ADEUDO", this.IdAgua;
        const datoRetorno = await this.registroBitacoraService.add(this.registroBitacora).toPromise();
      }
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarCertificadoNoAdeudo");
    }
  }

  //====================================================
  //Función de muestra.
  //====================================================
  async guardarCertificadoNoAdeudo() {
    try {
      if (this.certificadoNoAdeudoForm.invalid) {
        throw new Error("No paso las validaciones.");
      }

      this.certificadoNoAdeudo = this.certificadoNoAdeudoForm.value;

      if (this.certificadoNoAdeudo.id) {
        this.updateCertificadoNoAdeudo(this.certificadoNoAdeudo);
      } else {
        this.certificadoNoAdeudo.id = 0;
        await this.addCertificadoNoAdeudo(this.certificadoNoAdeudo);
      }
      this.certificadoNoAdeudoOutput.emit(this.certificadoNoAdeudo);
      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarCertificadoNoAdeudo");


    }
  }

  //====================================================
  //Metodos para obtener datos del servicio
  //====================================================
  async addCertificadoNoAdeudo(certificadoNoAdeudo) {
    try {
      const datoretorno = await this.certificadoNoAdeudoService
        .add(certificadoNoAdeudo)
        .toPromise();
      this.certificadoNoAdeudo = datoretorno;
      this.certificadoNoAdeudoForm.patchValue(this.certificadoNoAdeudo);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addCertificadoNoAdeudo");
    }
  }

  async updateCertificadoNoAdeudo(certificadoNoAdeudo: CertificadoNoAdeudo) {
    try {
      const datoRetorno = await this.certificadoNoAdeudoService
        .update(certificadoNoAdeudo)
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateCertificadoNoAdeudo");
    }
  }

  async deleteCertificadoNoAdeudo(certificadoNoAdeudo: CertificadoNoAdeudo) {
    try {
      const datoRetorno = await this.certificadoNoAdeudoService
        .delete(certificadoNoAdeudo.id)
        .toPromise();
      this.getAllCertificadoNoAdeudo();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteCertificadoNoAdeudo");
    }
  }

  async getCertificadoNoAdeudo(id: number) {
    try {
      const datoRetorno = await this.certificadoNoAdeudoService
        .getSingle(id)
        .toPromise();
      this.certificadoNoAdeudoForm.patchValue(datoRetorno);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCertificadoNoAdeudo");
    }
  }

  async getAllCertificadoNoAdeudo() {
    try {
      const datoRetorno = await this.certificadoNoAdeudoService
        .getAll()
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllCertificadoNoAdeudo");
    }
  }

  async imprimeCertificado() {
    this.certificadoNoAdeudo = this.certificadoNoAdeudoForm.value;
    //const parametro = idPago;
    console.log("se manda-->", this.certificadoNoAdeudo, this.cetSolicitud, this.idConcepto);
    this.auxJasper = new AuxJasper();
    this.auxJasper.JasperReport.nombreReporte = ""

    if(this.idConcepto == 1119){
      this.auxJasper.JasperReport.nombreReporte = "CertificadonoAdeudo";
    }  else if(this.idConcepto == 1526){
      this.auxJasper.JasperReport.nombreReporte = "CertificadonoAdeudodePrediosBaldios"
    }

    if(this.auxJasper.JasperReport.nombreReporte){
      this.auxJasper.JasperReport.tipo = "pdf";
      const _id_solicitud_detalle = new ParametroJasper();
      _id_solicitud_detalle.nombre = "_id_solicitud";
      _id_solicitud_detalle.valor = this.cetSolicitud + "";

      if (this.cetSolicitud) {
        await this.auxJasper.ParametroJasper.push(_id_solicitud_detalle);
      }
    }
    
    
    // -- Parametros --

    /*const _idAgua = new ParametroJasper();
    _idAgua.nombre = "_idAgua";
    _idAgua.valor = this.certificadoNoAdeudo.id + "";

    const _cuenta_predial = new ParametroJasper();
    _cuenta_predial.nombre = "_cuenta_predial";
    _cuenta_predial.valor = this.certificadoNoAdeudo.cuentaPredial + "";

    const _cuenta_agua_anterior = new ParametroJasper();
    _cuenta_agua_anterior.nombre = "_cuenta_agua_anterior";
    _cuenta_agua_anterior.valor =
      this.certificadoNoAdeudo.cuentaAguaAnterior + "";

    const _cuenta_agua = new ParametroJasper();
    _cuenta_agua.nombre = "_cuenta_agua";
    _cuenta_agua.valor = this.certificadoNoAdeudo.cuentaAgua + "";

    const id_usuario = new ParametroJasper();
    id_usuario.nombre = "id_usuario";
    id_usuario.valor = this.usuario.id + "";*/

    


    /*if (this.certificadoNoAdeudo.cuentaAgua) {
      await this.auxJasper.ParametroJasper.push(_cuenta_agua);
    }
    if (this.certificadoNoAdeudo.cuentaAguaAnterior) {
      await this.auxJasper.ParametroJasper.push(_cuenta_agua_anterior);
    }
    if (this.certificadoNoAdeudo.id) {
      await this.auxJasper.ParametroJasper.push(_idAgua);
    }
    if (this.certificadoNoAdeudo.cuentaPredial) {
      await this.auxJasper.ParametroJasper.push(_cuenta_predial);
    }
    if (this.usuario) {
      await this.auxJasper.ParametroJasper.push(id_usuario);
    }*/
    

    let flujoSolicitudes = new FlujoTramitesInput();
    flujoSolicitudes.idSolicitudDetalle = this.IdSolicitud;
    flujoSolicitudes.idUsuario = this.usuario.id;
    flujoSolicitudes.inicio = false;
    await this.flujoTramitesInputService.add(flujoSolicitudes).toPromise();
    
    if (
      /*!this.certificadoNoAdeudo.cuentaPredial &&
      !this.certificadoNoAdeudo.id &&
      !this.certificadoNoAdeudo.cuentaAguaAnterior &&
      !this.certificadoNoAdeudo.cuentaAgua*/
      !this.cetSolicitud
    ) {
      this.muestraMensaje.notification(
        "CAPTURE AL MENOS UN CRITERIO DE BÚSQUEDA",
        "top",
        "center"
      );
    } else {
      console.log("Visor", this.certificadoNoAdeudo);
      console.log("Agui va");
      // await $(".solicitud").modal("show"); //Para mostrar en forma de Poppup
      //this.router.navigateByUrl("componentes/visor", { state: this.auxJasper }); // Para mostrarlo con pagina independiente
      this.showDialog();

      
    }
    await console.log("Paso por imprimeCertificado");

  }
  async isLoggedIn(){      
    let status = false;      
    if (localStorage.getItem('isLoggedIn') == "true") {      
       status = true;      
    }    
    else {      
       status = false;      
       }      
    return status;      
   
    } 
  

  
}
